import React, { useLayoutEffect, useState, useContext, useRef } from 'react';

import * as S from './styles';
import { BannerProps } from 'types/InputsGridOfBannersProps';
import Check from 'components/Buttons/Check';
import SimpleInput from 'components/SimpleInput';
import Modal from 'components/Modal';
import InputImgBigger from 'components/InputImgBigger';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { returListOptionsDynamicPage, verifyIfFormCanSave } from './functions';
import DynamicPageContext from 'context/DynamicPage';
import SystemNotifyContext from 'context/SystemNotifyContext';
import {
	formatDateToISO,
	formatToDateCustom,
	generateUid
} from 'utils/functions';

const initialState: BannerProps = {
	id: '',
	file_id: '',
	file_path: '',
	name: '',
	width: 100, //ancho
	redirect_type: '',
	redirect_value: '',
	height: '120',
	has_modal: false,
	modal: {
		file_id: '',
		file_path: '',
		height: '',
		redirect_type: '',
		redirect_value: ''
	},
	schedule_start: '',
	schedule_end: '',
	countdown: false,
	reference_value: '', //url do video
	bannerDimenssions: {
		height: 0,
		width: 0
	},
	query: ''
};

interface FormAddBannerInGridProps {
	bannerToEdit: BannerProps | null;
	setBannerToEdit: React.Dispatch<React.SetStateAction<BannerProps | null>>;
	isFormBannerOpen: boolean;
	setIsFormBannerOpen: React.Dispatch<React.SetStateAction<boolean>>;
	functionToSave: any;
}

export default function FormAddBannerInGrid({
	bannerToEdit,
	setBannerToEdit,
	isFormBannerOpen,
	setIsFormBannerOpen,
	functionToSave = () => {}
}: FormAddBannerInGridProps) {
	initialState.id = generateUid();

	const hasRun = useRef(false);

	const { dynamicPagesList } = useContext(DynamicPageContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [dataForm, setDataForm] = useState<BannerProps>(initialState);
	const [useVideo, setUseVideo] = useState(false);
	const [isShowDateInputs, setIsShowDateInputs] = useState(false);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function cancel() {
		setIsFormBannerOpen(false);
		setDataForm(initialState);
		setBannerToEdit(null);
	}

	function saveBanner() {
		const canSave = verifyIfFormCanSave(
			dataForm,
			setDataForm,
			useVideo,
			handleNotify
		);

		if (canSave) {
			functionToSave(dataForm);
			setIsFormBannerOpen(false);
			setDataForm(initialState);
		}
	}

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	//mostra o a url da edição se for por url
	useLayoutEffect(() => {
		if (!hasRun.current && dataForm && dataForm.reference_value !== '') {
			if (dataForm.reference_value !== '') {
				setUseVideo(true);
			}
			hasRun.current = true;
		}
	}, [dataForm]);

	//mostra a data na edição se tiver dado
	useLayoutEffect(() => {
		if (dataForm.schedule_start !== '') {
			setIsShowDateInputs(true);
		}
	}, [dataForm]);

	//reseta os dados de agendamento caso feche a tela
	useLayoutEffect(() => {
		if (!isShowDateInputs) {
			setDataForm((obj) => ({
				...obj,
				countdown: false,
				schedule_end: '',
				schedule_start: ''
			}));
		}
	}, [isShowDateInputs]);

	//Se estiver em modo edição salva o dado no estado
	useLayoutEffect(() => {
		if (bannerToEdit !== null) {
			setTimeout(() => {
				setDataForm(bannerToEdit);
			}, 100);
		}
	}, []);

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<Modal
			isOpenProps={isFormBannerOpen}
			setIsOpenModal={() => {
				cancel();
			}}
			title={bannerToEdit === null ? 'Adicionar Banner' : 'Editar Banner'}
			buttonClose={false}
		>
			<S.container>
				<S.allInputsBox>
					<Check
						text="Deseja adicionar vídeo?"
						isChecked={useVideo}
						setIsChecked={setUseVideo}
					/>

					{useVideo ? (
						<SimpleInput
							label="Url do vídeo"
							initialValue={dataForm.reference_value}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									reference_value: value,
									file_id: '',
									file_path: ''
								}));
							}}
						/>
					) : (
						<InputImgBigger
							imgHeight={250}
							label="Banner"
							idImagem="FormAddBanner"
							initialImage={
								dataForm.file_id === '' ? '' : `${dataForm.file_path}`
							}
							getImage={(value: any) => {
								setDataForm((obj) => {
									return {
										...obj,
										reference_value: '',
										file_id: value.id,
										file_path: value?.url || value.relativePath || ''
									};
								});
							}}
						/>
					)}

					<S.twoInputs>
						<SimpleInput
							label="Título *"
							initialValue={dataForm.name}
							getValue={(value: string) => {
								setDataForm((obj) => ({ ...obj, name: value }));
							}}
						/>

						<SimpleInput
							label="Query"
							initialValue={dataForm.query}
							getValue={(value: string) => {
								setDataForm((obj) => ({ ...obj, query: value }));
							}}
						/>
					</S.twoInputs>

					<S.twoInputs>
						<SimpleInput
							paddingInLineEnd
							typeInput="number"
							placeHolder="Valor padrão 120"
							label="Altura (px) *"
							initialValue={dataForm.height}
							getValue={(value: string) => {
								setDataForm((obj) => ({ ...obj, height: value }));
							}}
						/>

						<SimpleInput
							paddingInLineEnd
							typeInput="number"
							label="Largura (%)"
							initialValue={dataForm.width}
							getValue={(value: string) => {
								setDataForm((obj) => ({ ...obj, width: parseInt(value) }));
							}}
						/>
					</S.twoInputs>

					<S.twoInputs>
						<SelectInput
							list={optionsRedirectType}
							getValue={(value: SelectInputItemProps | '') => {
								setDataForm((obj) => ({
									...obj,
									redirect_type: value === '' ? value : (value?.id as string)
								}));
							}}
							initialValue={
								dataForm.redirect_type === ''
									? optionsRedirectType[0]
									: findOptionOnListById(
											dataForm.redirect_type || '',
											optionsRedirectType
										)
							}
							label="Tipo de redirecionamento *"
						/>

						{(dataForm.redirect_type === '' ||
							dataForm.redirect_type === 'product' ||
							dataForm.redirect_type === 'url' ||
							dataForm.redirect_type === 'webview' ||
							dataForm.redirect_type === 'query' ||
							dataForm.redirect_type === 'screen_app') && (
							<SimpleInput
								label="Valor do redirecionamento *"
								initialValue={dataForm.redirect_value}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										redirect_value: value
									}));
								}}
							/>
						)}

						{dataForm.redirect_type === 'app_screen' && (
							<SelectInput
								list={optionsDynamicScreen}
								getValue={(value: SelectInputItemProps | '') => {
									setDataForm((obj) => ({
										...obj,
										redirect_value: value === '' ? value : (value?.id as string)
									}));
								}}
								initialValue={
									dataForm.redirect_value === ''
										? ''
										: findOptionOnListById(
												dataForm.redirect_value || '',
												optionsDynamicScreen
											)
								}
								label="Valor redirecionamento *"
							/>
						)}
					</S.twoInputs>

					<Check
						text="Modal"
						isChecked={dataForm.has_modal}
						setIsChecked={() => {
							setDataForm((obj) => ({ ...obj, has_modal: !obj.has_modal }));
						}}
					/>

					{dataForm.has_modal && (
						<>
							<InputImgBigger
								imgHeight={250}
								label="Banner da modal"
								idImagem="FormAddBannerModal"
								initialImage={
									dataForm.modal.file_path === ''
										? ''
										: `${dataForm.modal.file_path}`
								}
								getImage={(value: any) => {
									setDataForm((obj) => {
										return {
											...obj,
											modal: {
												...obj.modal,
												file_id: value.id,
												file_path: value?.url || value.relativePath || ''
											}
										};
									});
								}}
							/>

							<SimpleInput
								paddingInLineEnd
								typeInput="number"
								label="Altura da modal"
								initialValue={dataForm.modal.height}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										modal: { ...obj.modal, height: value }
									}));
								}}
							/>

							<S.twoInputs>
								<SelectInput
									list={optionsRedirectType}
									getValue={(value: SelectInputItemProps | '') => {
										setDataForm((obj) => ({
											...obj,
											modal: {
												...obj.modal,
												redirect_type:
													value === '' ? value : (value?.id as string)
											}
										}));
									}}
									initialValue={
										dataForm.modal.redirect_type === ''
											? optionsRedirectType[0]
											: findOptionOnListById(
													dataForm.modal.redirect_type || '',
													optionsRedirectType
												)
									}
									label="Tipo de redirecionamento *"
								/>

								{(dataForm.redirect_type === '' ||
									dataForm.redirect_type === 'product' ||
									dataForm.redirect_type === 'url' ||
									dataForm.redirect_type === 'webview' ||
									dataForm.redirect_type === 'query' ||
									dataForm.redirect_type === 'screen_app') && (
									<SimpleInput
										label="Valor do redirecionamento *"
										initialValue={dataForm.modal.redirect_value}
										getValue={(value: string) => {
											setDataForm((obj) => ({
												...obj,
												modal: {
													...obj.modal,
													redirect_value: value
												}
											}));
										}}
									/>
								)}

								{dataForm.redirect_type === 'app_screen' && (
									<SelectInput
										list={optionsDynamicScreen}
										getValue={(value: SelectInputItemProps | '') => {
											setDataForm((obj) => ({
												...obj,
												modal: {
													...obj.modal,
													redirect_value:
														value === '' ? value : (value?.id as string)
												}
											}));
										}}
										initialValue={
											dataForm.modal.redirect_value === ''
												? ''
												: findOptionOnListById(
														dataForm.modal.redirect_value || '',
														optionsDynamicScreen
													)
										}
										label="Valor redirecionamento *"
									/>
								)}
							</S.twoInputs>
						</>
					)}

					<div style={{ display: 'none' }}>
						<Check
							text="Programação"
							isChecked={isShowDateInputs}
							setIsChecked={setIsShowDateInputs}
						/>

						{isShowDateInputs && (
							<>
								<S.twoInputs>
									<SimpleInput
										typeInput="datetime-local"
										label="Ínicio"
										initialValue={
											dataForm.schedule_start === ''
												? ''
												: formatToDateCustom(dataForm.schedule_start)
										}
										getValue={(value: string) => {
											setDataForm((obj) => {
												return {
													...obj,
													schedule_start: formatDateToISO(value)
												};
											});
										}}
										paddingInLineEnd
									/>

									<SimpleInput
										typeInput="datetime-local"
										label="Fim"
										initialValue={
											dataForm.schedule_end === ''
												? ''
												: formatToDateCustom(dataForm.schedule_end)
										}
										getValue={(value: string) => {
											setDataForm((obj) => {
												return {
													...obj,
													schedule_end: formatDateToISO(value)
												};
											});
										}}
										paddingInLineEnd
									/>
								</S.twoInputs>

								<Check
									text="Contagem regressiva"
									isChecked={dataForm.countdown}
									setIsChecked={() => {
										setDataForm((obj) => ({
											...obj,
											countdown: !obj.countdown
										}));
									}}
								/>
							</>
						)}
					</div>
				</S.allInputsBox>

				<S.containerBtns>
					<S.cancel onClick={cancel}>Cancelar</S.cancel>
					<S.save onClick={saveBanner}>Salvar</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
